import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { AuthGuard } from './guards/auth.guard';
import { ValidationComponent } from './pages/validation/validation.component';
import { RecoverComponent } from './pages/recover/recover.component';

export const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('../app/pages/pages.module').then(m => m.PagesModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'login-register',
    loadChildren: () => import('../app/pages/login-register/login-register.module').then(m => m.LoginRegisterModule),
  },
  {
    path: 'meet',
    loadChildren: () => import('../app/pages/meet/meet.module').then(m => m.MeetModule),
  },
  {
    path: 'validation/:token',
    component: ValidationComponent,
  },
  {
    path: 'recover/:token',
    component: RecoverComponent,
  },
  {
    path: '',
    redirectTo: 'login-register/login',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'login-register/login',
  },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
